// @ts-nocheck
// Removing typechecking this file due to type errors in NextJS in the extraction migration

import { ResultAsync } from "neverthrow";

import { StripeSdk } from "@zapier/stripe";

import { invoicePreviewQuery_account_invoicePreview_paymentIntent as PaymentIntentType } from "@zapier/checkout/esm/graphql-types";

export function confirmPaymentIntent(paymentIntent: PaymentIntentType) {
  return StripeSdk.get().andThen(stripeSdk =>
    ResultAsync.fromPromise(
      stripeSdk
        .confirmCardPayment(paymentIntent.clientSecret, {
          payment_method: paymentIntent.processorPaymentSourceId,
        })
        .then(result => {
          if (result.error) throw result.error;
          return result.paymentIntent;
        }),
      e => e as stripe.Error
    )
  );
}

//@ts-ignore
export function isStripeError(error: any): error is stripe.Error {
  return (
    "type" in error &&
    [
      "api_error",
      "card_error",
      "idempotency_error",
      "invalid_request_error",
    ].includes(error.type)
  );
}
